import { useMemo } from "react"
import { useOutletContext } from "react-router-dom"

import type { DeviceDashboardOutletContext } from "types/dashboard.types"

import TowerDevicePosition from "./TowerDevicePosition"
import LegacyTowerDevicePosition from "./LegacyTowerDevicePosition"
import PowerlineDevicePosition from "./PowerlineDevicePosition"

interface DevicePositionProps {
  deviceId: number | string
}

const DevicePosition = ({ deviceId }: DevicePositionProps) => {
  const { device } = useOutletContext<DeviceDashboardOutletContext>()
  const deviceIds = useMemo(() => [Number(deviceId)], [deviceId])
  const installationType = device.settings?.installation_type ?? "powerline"

  if (installationType === "tower") {
    if (device.settings?.features?.tower_health?.enabled === true) {
      return <TowerDevicePosition deviceId={deviceId} deviceIds={deviceIds} />
    }
    return <LegacyTowerDevicePosition deviceId={deviceId} deviceIds={deviceIds} />
  }

  return <PowerlineDevicePosition deviceId={deviceId} deviceIds={deviceIds} />
}

export default DevicePosition
